import React from 'react'

const BreastPump: React.FC<React.HTMLAttributes<SVGElement>> = () => (
  <svg
    fill="none"
    height="72"
    viewBox="0 0 72 72"
    width="72"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57.307 65.925C57.1382 65.925 56.9695 65.8913 56.8007 65.8013C52.762 63.765 49.5895 60.615 47.8682 56.9363C45.9332 52.7963 45.9332 48.0713 47.857 44.2913C48.8357 42.3675 50.2645 40.77 51.637 39.2175C53.0207 37.665 54.337 36.1913 55.1807 34.4475C56.8007 31.1175 56.3957 26.8875 54.1795 23.9175C51.9745 20.9475 48.0257 19.35 44.3695 19.9463C43.762 20.0475 43.177 19.6313 43.0757 19.0125C42.9745 18.3938 43.3907 17.82 44.0095 17.7188C48.4757 16.9988 53.2795 18.945 55.9795 22.5675C58.6795 26.19 59.1632 31.365 57.1945 35.4263C56.2157 37.4513 54.7307 39.105 53.302 40.7138C51.9632 42.2213 50.692 43.6388 49.837 45.3038C48.2507 48.42 48.2732 52.5038 49.8932 55.9688C51.4007 59.1863 54.202 61.965 57.802 63.765C58.3532 64.0463 58.5782 64.7213 58.297 65.2725C58.0945 65.6663 57.7007 65.8913 57.2957 65.8913V65.925H57.307Z"
      fill="#6E3264"
    />
    <path
      d="M41.616 37.5641V56.9141C40.1197 57.4878 39.1297 58.2753 36.3622 58.2753C32.0535 58.2753 32.0535 56.3516 27.7335 56.3516C24.966 56.3516 23.976 57.1391 22.4685 57.7128V37.5753C22.4685 34.7178 24.786 32.3891 27.6547 32.3891H36.4297C39.2872 32.3891 41.6047 34.7066 41.6047 37.5753H41.616V37.5641Z"
      fill="url(#paint0_linear_7333_22075)"
    />
    <path
      d="M36.486 23.3216C37.4085 23.3216 38.1622 22.5678 38.1622 21.6453V17.5616C38.1622 16.6391 37.4085 15.8853 36.486 15.8853H27.5422C26.6197 15.8853 25.866 16.6391 25.866 17.5616V21.6453C25.866 22.5678 26.6197 23.3216 27.5422 23.3216H28.296V26.7528C26.9347 26.8653 25.866 28.0016 25.866 29.3853V29.7116C25.866 31.1741 27.0585 32.3666 28.521 32.3666H35.5072C36.9697 32.3666 38.1622 31.1741 38.1622 29.7116V29.3853C38.1622 27.9903 37.0935 26.8653 35.7322 26.7528V23.3216H36.486Z"
      fill="url(#paint1_linear_7333_22075)"
    />
    <path
      d="M37.8922 14.5128V23.4566C37.8922 24.3791 38.646 25.1328 39.5685 25.1328H43.6522C44.5747 25.1328 45.3285 24.3791 45.3285 23.4566V14.5128C45.3285 13.5903 44.5747 12.8366 43.6522 12.8366H39.5685C38.646 12.8366 37.8922 13.5903 37.8922 14.5128Z"
      fill="url(#paint2_linear_7333_22075)"
    />
    <path
      d="M27.3172 18.8103C26.5072 25.2453 22.3222 30.0378 17.946 29.5766C19.8472 29.5766 21.9847 24.5816 22.7835 18.2366C23.571 11.9478 22.7722 6.64908 20.9722 6.06408C25.2922 6.75033 28.116 12.3978 27.306 18.7991H27.3172V18.8103Z"
      fill="url(#paint3_linear_7333_22075)"
    />
    <path
      d="M22.041 18.1241C21.2422 24.4691 19.0935 29.4528 17.2035 29.4641C17.1585 29.4641 17.1135 29.4641 17.0685 29.4528C15.1447 29.2166 14.2335 23.7491 15.0547 17.2466C15.876 10.7441 18.1147 5.65908 20.0385 5.91783C20.106 5.91783 20.1735 5.94033 20.2297 5.96283C22.0185 6.53658 22.8285 11.8466 22.041 18.1353V18.1241Z"
      fill="url(#paint4_linear_7333_22075)"
    />
    <path
      d="M41.571 60.5141C41.571 63.3716 39.2535 65.6891 36.396 65.6891H27.621C24.7635 65.6891 22.4347 63.3716 22.4347 60.5141V57.4091C23.9422 56.8353 24.9322 56.0478 27.6997 56.0478C32.0197 56.0478 32.0197 57.9716 36.3285 57.9716C39.096 57.9716 40.086 57.1841 41.5822 56.6103H41.571V60.5141Z"
      fill="url(#paint5_linear_7333_22075)"
    />
    <path
      d="M38.3872 41.6366H32.706C32.0872 41.6366 31.581 41.1303 31.581 40.5116C31.581 39.8928 32.0872 39.3866 32.706 39.3866H38.3872C39.006 39.3866 39.5122 39.8928 39.5122 40.5116C39.5122 41.1303 39.006 41.6366 38.3872 41.6366Z"
      fill="#6E3264"
    />
    <path
      d="M38.3872 47.4641H32.706C32.0872 47.4641 31.581 46.9578 31.581 46.3391C31.581 45.7203 32.0872 45.2141 32.706 45.2141H38.3872C39.006 45.2141 39.5122 45.7203 39.5122 46.3391C39.5122 46.9578 39.006 47.4641 38.3872 47.4641Z"
      fill="#6E3264"
    />
    <path
      d="M38.3872 53.2803H32.706C32.0872 53.2803 31.581 52.7741 31.581 52.1553C31.581 51.5366 32.0872 51.0303 32.706 51.0303H38.3872C39.006 51.0303 39.5122 51.5366 39.5122 52.1553C39.5122 52.7741 39.006 53.2803 38.3872 53.2803Z"
      fill="#6E3264"
    />
    <path
      d="M43.6072 11.4191H39.5235C37.9822 11.4191 36.7222 12.6791 36.7222 14.2203V14.5016C36.6322 14.5016 36.5422 14.4791 36.4522 14.4791H27.6997C27.1822 9.33783 24.426 5.31033 20.5335 4.60158C20.421 4.56783 20.3085 4.54533 20.1397 4.52283C19.701 4.47783 19.0035 4.52283 18.2497 5.10783C16.3147 6.59283 14.6047 11.1941 13.896 16.8191C13.1872 22.4441 13.6935 27.3153 15.1897 29.2503C15.786 30.0041 16.4385 30.2291 16.8772 30.2853H17.0347V30.3078C17.271 30.3303 17.5072 30.3416 17.7435 30.3416H17.7547C21.1747 30.3416 24.3135 27.7653 26.1472 23.8166C26.4397 23.9853 26.7772 24.0978 27.126 24.1428V25.5941C25.686 26.1341 24.696 27.5066 24.696 29.1153V29.4416C24.696 30.1728 24.9097 30.8591 25.2697 31.4328C22.9522 32.3666 21.3097 34.6391 21.3097 37.2941V56.6328H21.2872V60.5253C21.2872 64.0016 24.1222 66.8253 27.5985 66.8253H36.3847C39.861 66.8141 42.6847 63.9903 42.6847 60.5141V57.4203H42.7072V37.2941C42.7072 34.6278 41.0422 32.3328 38.691 31.4103C39.0397 30.8366 39.2535 30.1616 39.2535 29.4416V29.1153C39.2535 27.5066 38.2635 26.1341 36.8235 25.5941V24.1428C36.8235 24.1428 36.8685 24.1316 36.9022 24.1203C37.296 25.2003 38.3197 25.9766 39.5235 25.9766H43.6072C45.1485 25.9766 46.4085 24.7166 46.4085 23.1753V14.2203C46.4085 12.6791 45.1485 11.4191 43.6072 11.4191ZM17.1585 28.0578C16.506 27.7428 15.2685 24.0191 16.1347 17.1116C17.0235 10.0916 19.1947 6.81783 19.8472 6.75033H19.8585C19.9822 6.80658 20.1285 6.97533 20.2747 7.26783C20.9047 8.53908 21.591 12.0491 20.8822 17.6966C19.9822 24.7053 17.8335 27.9791 17.1585 28.0578ZM25.4047 18.2703C25.2697 19.3503 25.0222 20.3853 24.696 21.3528C23.8297 23.9403 22.3672 26.0216 20.646 27.1466C21.456 25.5153 22.0747 23.4453 22.5022 21.4653C22.7722 20.2278 22.9747 19.0128 23.1097 17.9778C23.3235 16.2566 23.4697 14.0291 23.391 11.8916C23.346 10.7103 23.2335 9.55158 23.0197 8.51658C24.426 10.0803 25.3372 12.5328 25.506 15.3228C25.5622 16.2791 25.5397 17.2691 25.4047 18.2703ZM40.446 60.5253C40.446 62.7528 38.6347 64.5753 36.396 64.5753H27.6097C25.371 64.5753 23.5485 62.7641 23.5485 60.5253V58.1741C23.6047 58.1516 23.661 58.1178 23.7172 58.0953C23.751 58.0841 23.796 58.0616 23.8297 58.0503L23.8747 58.0278C24.8985 57.5778 25.7872 57.1841 27.6885 57.1841C29.5897 57.1841 30.501 57.5891 31.536 58.0391H31.5472C32.661 58.5341 33.921 59.0966 36.306 59.0966C38.2522 59.1078 39.4447 58.7366 40.4235 58.3428V60.5141L40.446 60.5253ZM40.446 37.2716V55.8678C40.356 55.9128 40.2547 55.9466 40.1647 55.9916H40.131L40.131 56.0028C39.1072 56.4528 38.2185 56.8466 36.3622 56.8578H36.3172C34.416 56.8578 33.516 56.4528 32.481 56.0028H32.4697C31.356 55.4966 30.0847 54.9341 27.6885 54.9341V54.9116C25.731 54.9116 24.5272 55.2941 23.5485 55.6991V37.2716C23.5485 35.0328 25.371 33.2103 27.6097 33.2103H28.1835C28.2847 33.2103 28.3747 33.2216 28.476 33.2216H35.4735C35.5747 33.2216 35.6647 33.2216 35.766 33.2103H36.396C38.6235 33.2103 40.446 35.0328 40.446 37.2716ZM36.9585 21.3641C36.9585 21.5441 36.8572 21.7016 36.7222 21.8028C36.6322 21.8703 36.531 21.9153 36.4072 21.9153H34.5285V27.5066L35.5635 27.5966C36.3622 27.6753 36.9697 28.3166 36.9697 29.1153V29.4416C36.9697 30.2853 36.2835 30.9716 35.4397 30.9716H28.4535C27.6097 30.9716 26.9235 30.2853 26.9235 29.4416V29.1153C26.9235 28.3166 27.531 27.6641 28.3297 27.5966L29.3647 27.5066V21.9153H27.486C27.261 21.9153 27.081 21.7803 26.991 21.6003L27.7785 16.7291H36.4072C36.531 16.7291 36.6322 16.7741 36.7222 16.8416C36.8572 16.9428 36.9585 17.1003 36.9585 17.2803V21.3641ZM44.1585 23.1978C44.1585 23.5016 43.911 23.7491 43.6072 23.7491H39.5235C39.2197 23.7491 38.9722 23.5016 38.9722 23.1978V14.2428C38.9722 13.9391 39.2197 13.6916 39.5235 13.6916H43.6072C43.911 13.6916 44.1585 13.9391 44.1585 14.2428V23.1978Z"
      fill="#6E3264"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_7333_22075"
        x1="19.2122"
        x2="49.4182"
        y1="61.8152"
        y2="28.5561"
      >
        <stop stopColor="#64AF68" />
        <stop offset="1" stopColor="#A4D4FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_7333_22075"
        x1="34.0941"
        x2="15.8757"
        y1="14.4633"
        y2="57.8552"
      >
        <stop stopColor="#F4D04E" />
        <stop offset="1" stopColor="#E96C4C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_7333_22075"
        x1="36.9722"
        x2="18.8143"
        y1="11.2374"
        y2="59.4643"
      >
        <stop stopColor="#F4D04E" />
        <stop offset="1" stopColor="#E96C4C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_7333_22075"
        x1="13.619"
        x2="46.474"
        y1="35.6568"
        y2="35.6568"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F6D2FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_7333_22075"
        x1="13.574"
        x2="46.4197"
        y1="35.6355"
        y2="35.6355"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F6D2FB" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_7333_22075"
        x1="22.877"
        x2="65.1833"
        y1="-19.2674"
        y2="-0.585138"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F6D2FB" />
      </linearGradient>
    </defs>
  </svg>
)

export default BreastPump
